import { initSmoothScroll } from "./scripts/smooth-scroll";
import { initFaqAccordion } from "./scripts/faq-accordion";
import { initFormBranching } from "./scripts/form-branching";
import { initRevealOnScroll } from "./scripts/reveal-on-scroll";
import { initContactForm } from "./scripts/contact-form";
import type { UseCase } from "./scripts/form-branching";

initSmoothScroll();
initRevealOnScroll();
initFaqAccordion(document.querySelector<HTMLElement>("[data-faq]"));

const form = document.querySelector<HTMLFormElement>("[data-contact-form]");
const { applyInitialUseCase } = initFormBranching(form);

document.querySelectorAll<HTMLAnchorElement>("a[data-use-case]").forEach((link) => {
  link.addEventListener("click", () => {
    const useCase = link.dataset.useCase as UseCase | undefined;
    if (useCase) applyInitialUseCase(useCase);
  });
});

initContactForm(form, {
  endpoint: import.meta.env.VITE_CONTACT_ENDPOINT,
  mailto: import.meta.env.VITE_CONTACT_EMAIL,
});
